import { useFormikContext } from 'formik'
import { VField } from '../../components/Fields'
import { Intervento } from '../../types'
import { Button } from 'react-bootstrap'
import { useState } from 'react'

export default function FormEsitoRiesame({
  intervento,
}: {
  intervento: Intervento | null
}) {
  const { values, setFieldValue } = useFormikContext<Intervento>()
  const [esitoRiesame, setEsitoRiesame] = useState(false)
  return (
    <div className="row">
      <div className="col-md-12">
        Esegui nuovamente una la validazione della certificazione.
      </div>
      <div>
        <div className="d-flex align-items-center mt-3">
          <div className="heading-h4">Esito certificazione</div>
          {intervento?.esito !== '' && (
            <div className="d-flex align-items-center ms-4">
              {intervento?.esito === 'positivo' ? (
                <div className="d-flex align-items-center">
                  <span className="material-icons me-2 text-success">
                    check
                  </span>
                  <span className="heading-h3 text-capitalize">
                    {intervento?.esito}
                  </span>
                </div>
              ) : (
                <div className="d-flex align-items-center">
                  <span className="material-icons me-2 text-danger">close</span>
                  <span className="heading-h3 text-capitalize">
                    {intervento?.esito}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="text-body-secondary mt-2">
          Seleziona qui per validare o invalidare l’esito della certificazione.
        </div>
        {!esitoRiesame && (
          <div className="mt-3 d-flex align-items-center">
            <Button
              variant="danger"
              className="text-white d-flex align-items-center"
              onClick={() => {
                setEsitoRiesame(true)
                setFieldValue('esito_riesame', 'invalido')
              }}
            >
              <span
                className="material-icons me-2"
                style={{
                  fontSize: 16,
                }}
              >
                close
              </span>
              Invalida
            </Button>
            <Button
              variant="success"
              className="text-white d-flex align-items-center ms-2"
              onClick={() => {
                setEsitoRiesame(true)
                setFieldValue('esito_riesame', 'conforme')
              }}
            >
              <span
                className="material-icons me-2"
                style={{
                  fontSize: 16,
                }}
              >
                check
              </span>
              Convalida
            </Button>
          </div>
        )}
        {esitoRiesame && (
          <div className="mt-3 d-flex align-items-center">
            {values.esito_riesame === 'conforme' ? (
              <div className="d-flex align-items-center">
                <span className="material-icons me-2 text-success">check</span>
                <span className="p-sm text-capitalize text-success">
                  {values.esito_riesame}
                </span>
              </div>
            ) : (
              <div className="d-flex align-items-center">
                <span className="material-icons me-2 text-danger">close</span>
                <span className="p-sm text-capitalize text-danger">
                  {values.esito_riesame}
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
